/*
 Created by qing on 2020/10/14
 Des: 关联记录
 */

import BaseItem from "../BaseItem";
import {DATA_TYPE__JSON, FORM_ITEM__RELATE_RECORD} from "../types";
import DropDown from "./Dropdown";

class RelateRecord extends BaseItem {
  constructor() {
    super()

    // 填写内容
    this.value = {
      instanceIdList: [],
      appId: "",
      formId: "",
      viewId: "",
      showTitleList: [] //后端返回空数组
    }

    this.relateAppId = ''
    this.relateFormId = ''
    this.relateCount = 'MANY' //ONE 单条 MANY 多条
    this.showStyle = 'CARD'  //CARD 卡片 LIST 列表 DROPDOWN 下拉框
    this.showFieldIdList = []  // 显示字段
    this.coverImageFieldId = '' //封面图
    this.titleFieldId = '' // 标题
    this.filterInfo = {
      relation: "and",  //条件之间的关系 and查询 或者 or 查询
      notJumpEmpty: 0, //是否不跳过空值过滤 0 跳过 1 不跳过
      conditionList: []
    } //扫码结果可修改
    this.allowAdd = 0 //是否允许新建记录
    this.relateView = 0 // 关联视图
    this.relateViewId = ''

    this.addInstanceList = []
    this.deleteInstanceList = []
  }

  get title() {
    return this.fieldTitle || RelateRecord._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

RelateRecord._title = '关联记录'
RelateRecord.type = FORM_ITEM__RELATE_RECORD
RelateRecord.use = true
RelateRecord.icon = 'iconfont icon-relate-record'
RelateRecord.prototype.icon = 'iconfont icon-relate-record'

// 组件类型
RelateRecord.prototype.type = RelateRecord.type
// 数据类型
RelateRecord.prototype.dataType = DATA_TYPE__JSON
RelateRecord.prototype.getValue = function () {
  return this.value
}
RelateRecord.prototype.setValue = function (val) {
  if (val) {
    this.value.instanceIdList = val.instanceIdList
    this.value.appId = val.appId
    this.value.formId = val.formId
    this.value.viewId = val.viewId
    this.value.showTitleList = val.showTitleList
  } else {
    this.value = {
      instanceIdList: [],
      appId: "",
      formId: "",
      viewId: "",
      showTitleList: [] //后端返回空数组
    }
  }
}

RelateRecord.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    relateAppId: this.relateAppId,
    relateFormId: this.relateFormId,
    relateCount: this.relateCount,
    showStyle: this.showStyle,
    showFieldIdList: this.showFieldIdList,
    coverImageFieldId: this.coverImageFieldId,
    titleFieldId: this.titleFieldId,
    filterInfo: this.filterInfo,
    allowAdd: this.allowAdd,
    relateView: this.relateView,
    relateViewId: this.relateViewId
  }
}
RelateRecord.prototype.setConf = function (opts) {
  this.setBase(opts)

  this.relateAppId = opts.relateAppId
  this.relateFormId = opts.relateFormId
  this.relateCount = opts.relateCount
  this.showStyle = opts.showStyle
  if (opts.showFieldIdList) this.showFieldIdList = opts.showFieldIdList
  this.coverImageFieldId = opts.coverImageFieldId
  this.titleFieldId = opts.titleFieldId
  if (opts.filterInfo) this.filterInfo = opts.filterInfo
  this.allowAdd = opts.allowAdd
  this.relateView = opts.relateView
  this.relateViewId = opts.relateViewId
}
RelateRecord.prototype.valueToString = function (value) {
  return ''
}

export default RelateRecord
